<template>
  <div class="markdown-win">
    <markdownEditor ref="markdownView" :config="{height:300}"></markdownEditor>
    <div class="but-bar clearfix">
      <div class="user-info clearfix">
        <a href="" class="author">
          <img :src="imgSrc">
        </a>
        <span>{{userName}}</span>
      </div>
      <div class="but-group">
        <span @click="clearClick">清除回复</span>
        <span @click="previewClick">预览</span>
        <span @click="releaseClick">发布</span>
      </div>
    </div>
  </div>
</template>

<script>
import markdownEditor from "@/components/common/markdownEditor";

export default {
  name: "markdownWin",
  props:{
    author: Object
  },
  computed:{
    imgSrc:function (){
      if (this.author.authorIcon == undefined ||
          this.author.authorIcon == '' ||
          this.author.authorIcon == 'undefined'){
        return './static/image/gravatar.jpg';
      }else {
        return this.author.authorIcon;
      }
    },
    userName:function (){
      return this.author.authorName;
    },
  },
  methods:{
    clearClick:function (){
      this.$refs.markdownView.clear();
    },
    previewClick:function (){
      this.$refs.markdownView.previewing();
    },
    releaseClick:function (){
      let htmlStr = this.$refs.markdownView.getContent();
      if (htmlStr == 'undefined' || htmlStr == undefined || htmlStr == ''){
        return
      }
      this.$emit('event-release-reply', htmlStr, 'append');
      this.clearClick();
    }
  },
  components:{
    markdownEditor
  }
}
</script>

<style scoped>
.markdown-win{
  margin: 5px 15px;
}
.but-bar{
  top: 0px;
  margin: 0px;
  padding: 0px;
  position: relative;
  height: 50px;
  background-color: #fff;
}
.user-info{
  line-height: 50px;
  float: left;
}
.author{
  padding-left: 10px;
  display: block;
  width: 50px;
  height: 50px;
  float: left;
}
.author img{
  margin-top: 8px;
  width: 35px;
  height: 35px;
  border-radius: 5px;
}
.user-info span{
  margin-left: 5px;
}

.but-group{
  float: right;
  margin-right: 10px;
}
.but-group span{
  display: block;
  border-radius: 5px;
  border: 1px solid #2e7eee;
  float: left;
  margin-left: 10px;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  color: #2e7eee;
}
.but-group span:hover{
  background-color: #2e7eee;
  color: #fff;
}

</style>
